import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdAdminService } from 'src/app/admin/ad-admin/ad-admin.service';
import { NoDataComponent } from 'src/app/Theme/shared/components/no-data/no-data.component';
import { SpinnerService } from 'src/app/Theme/shared/service/spinner.service';
import { SharedModule } from 'src/app/Theme/shared/shared.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule, NoDataComponent, SharedModule, TranslateModule],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {
  @Input() embedded = false;
  title: string = 'About Us';
  content: string = '';
  isLoading: boolean = true;

  constructor(
    private adAdminService: AdAdminService,
    private spinnerService: SpinnerService,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.loadAboutUs();
  }

  private loadAboutUs(): void {
    this.isLoading = true;
    this.spinnerService.show();
    this.adAdminService.getFooterAboutUs({}).subscribe({
      next: (data: any) => {
        const record = this.pickSingleRecord(data);
        if (record) {
          this.title = record.title || this.title;
          this.content = record.content || '';
        }
        this.isLoading = false;
        this.spinnerService.hide();
      },
      error: (error) => {
        console.error('Error loading about us:', error);
        this.isLoading = false;
        this.spinnerService.hide();
      }
    });
  }

  private pickSingleRecord(data: any): any {
    if (!data) { return null; }
    if (Array.isArray(data)) { return data[0] ?? null; }
    if (data?.results && Array.isArray(data.results)) { return data.results[0] ?? null; }
    if (data?.data) { return data.data; }
    return data;
  }
}
